<template>
  <v-text-field
    v-model="computedValue"
    :label="label"
    :outlined="outlined"
    :dense="dense"
    @keydown="validate($event)"
    type="Number"
    :disabled="disabled"
    :hide-details="hideDetails"
    :error="error"
    :min="min"
  ></v-text-field>
</template>

<script>

/**
 * Component IntegerInput.vue
 *
 * @module IntegerInput
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/IntegerInput.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'IntegerInput',
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    min: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    validate(event) {
      const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keys = ['Backspace', 'ArrowRight', 'ArrowLeft'];

      if ([...numbers, ...keys].includes(event.key)) {
        return true;
      }

      event.preventDefault();
      return false;
    },
  },
};
</script>
